import React, { useState } from 'react';
import { Card, Collapse, List, Tag, Empty } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { WorkstationControlCenterQueryParams } from '@/services/workstationControlCenter.service';
import { useWccAlerts } from '@/hooks/useWorkstationControlCenter';

interface Props {
  params?: WorkstationControlCenterQueryParams;
  refreshInterval?: number;
}

const WorkstationSmartAlertsPanel: React.FC<Props> = ({ params, refreshInterval }) => {
  const navigate = useNavigate();
  const { data, isLoading } = useWccAlerts(params, refreshInterval);
  const alerts = data as { critical?: Record<string, unknown>[]; warnings?: Record<string, unknown>[] };
  const [expanded, setExpanded] = useState<string[]>(['critical']);

  const renderList = (list: Record<string, unknown>[] | undefined, color: string) => {
    if (!list?.length) return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="None" />;
    return (
      <List
        size="small"
        dataSource={list}
        renderItem={(a) => (
          <List.Item
            style={{ cursor: a.deepLink ? 'pointer' : 'default', borderLeft: `4px solid ${color}` }}
            onClick={() => a.deepLink && navigate(String(a.deepLink))}
          >
            <List.Item.Meta title={<><Tag>{String(a.type)}</Tag> {String(a.title)}</>} description={String(a.description)} />
          </List.Item>
        )}
      />
    );
  };

  return (
    <Card id="alerts" title="Smart alerts" style={{ marginTop: 16 }} loading={isLoading}>
      <Collapse
        activeKey={expanded}
        onChange={(k) => setExpanded(k as string[])}
        items={[
          { key: 'critical', label: `Critical (${alerts?.critical?.length ?? 0})`, children: renderList(alerts?.critical, '#ff4d4f') },
          { key: 'warnings', label: `Warnings (${alerts?.warnings?.length ?? 0})`, children: renderList(alerts?.warnings, '#faad14') },
        ]}
      />
    </Card>
  );
};

export default WorkstationSmartAlertsPanel;
